import React, { useEffect } from "react";
import apiCall from "../../utility/api";

type siteProp = {
    propTname: any;
    propdeviceCnt: any;
    proponedeviceCnt: any;
    propthirtyDeviceCnt: any;
    propninetyDeviceCnt: any;
    setLoader: React.Dispatch<React.SetStateAction<boolean>>; 
}



export const Tenant_dev = (props: siteProp) => {

    let currentDate = new Date()
    let yesterday = new Date(currentDate)
    yesterday.setDate(yesterday.getDate() - 1)

    const unixTimestamp_yes = Math.floor(yesterday.getTime() / 1000);

    const thirtydate = new Date();
    thirtydate.setDate(thirtydate.getDate() - 30);

    const unixTimestamp_thirty = Math.floor(thirtydate.getTime() / 1000);

    const ninedate = new Date();
    ninedate.setDate(ninedate.getDate() - 90);

    const unixTimestamp_nine = Math.floor(ninedate.getTime() / 1000);

    const date = new Date(Date.now());
    const unixTimestamp_tdy = Math.floor(date.getTime() / 1000);

    const getSiteDeviceList = async (tenant: any) => {
        props.setLoader(true);
        const { data, status } = await apiCall('/tenant/getCensusDeviceCount', { tenant });
        if (status === 'success' && data) {
            const coreCensusArray = data.filter((site) => site !== null && Object.keys(site).length > 0);
            const lengthOfOutput = coreCensusArray.length;

            if (lengthOfOutput !== 0) {
                const Devices = coreCensusArray.map((Joineddata) => {
                    return 1;
                });

                const Totdev = Devices.reduce((n, n2) => n + n2, 0);
                props.propdeviceCnt(Totdev);
            } else {
                const Totdev = 0;
                props.propdeviceCnt(Totdev);
            }
        }
    };
    useEffect(() => {
        getSiteDeviceList(props.propTname);
    }, [props.propTname]);


    const getSitesDeviceListOfOneday = async (siteName: any, bornYesDate: any, bornTdyDate: any) => {
        try {
            const { status, data } = await apiCall('/census/getCensusCount', { tenant: siteName, bornYesDate, bornTdyDate });
            if (status === 'success' && data) {
                props.proponedeviceCnt(data.totalRecords);
            }
        } catch (error) {
            console.error('getDeviceCountForDay API call failed: ', error);
        }finally {
            props.setLoader(false);
        }
    };
    useEffect(() => {
        getSitesDeviceListOfOneday(props.propTname, unixTimestamp_yes, unixTimestamp_tdy);
    }, [props.propTname]);


    const getSitesDeviceListOfThirtyday = async (siteName: any, bornthirtyDate: any, bornTdyDate: any) => {
        try {
            const { status, data } = await apiCall('/census/getCensusCount', { tenant: siteName, bornthirtyDate, bornTdyDate });
            if (status === 'success' && data) {
                props.propthirtyDeviceCnt(data.totalRecords);
            }
        } catch (error) {
            console.error('getDeviceCountThirtyDays API call failed: ', error);
            props.propthirtyDeviceCnt(0);
        }finally {
            props.setLoader(false);
        }
    };
    useEffect(() => {
        getSitesDeviceListOfThirtyday(props.propTname, unixTimestamp_thirty, unixTimestamp_tdy);
    }, [props.propTname]);


    const getSitesDeviceListOfNinety = async (siteName: any, bornninetyDate: any, bornTdyDate: any) => {
        try {
            const { status, data } = await apiCall('/census/getCensusCount', { tenant: siteName, bornninetyDate, bornTdyDate });

            if (status === 'success' && data) {
                props.propninetyDeviceCnt(data.totalRecords);
            }
        } catch (error) {
            console.error('getSitesDeviceninety API call failed: ', error);
            props.propninetyDeviceCnt(0);
        }finally {
            props.setLoader(false);
        }
    };
    useEffect(() => {
        getSitesDeviceListOfNinety(props.propTname, unixTimestamp_nine, unixTimestamp_tdy);
    }, [props.propTname]);


    return <>
    </>;
};
